import React, { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';

export const TermsPanel = ({ terms, testId }) => {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <div className="mb-5">
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-controls={id} data-testid={testId}
        className="flex items-center gap-1.5 text-xs font-display font-bold tracking-wider text-cyan hover:underline">
        ELIGIBILITY &amp; TERMS <ChevronDown size={14} aria-hidden="true" className={`transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
      </button>
      <dl id={id} hidden={!open} className="mt-3 space-y-2.5 rounded-xl p-4 text-xs leading-relaxed" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid var(--ar-border)' }}>
        {terms.map(([k, v]) => (
          <div key={k}>
            <dt className="font-display font-bold text-[var(--ar-text)]">{k}</dt>
            <dd className="text-muted">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
